<template>
<v-card outlined>
    <v-card-text class="d-flex justify-space-between flex-wrap">
        <Summary :params="summaryParams" :context="context"/>
        <v-card class="d-flex pa-1 align-center" outlined>
            <v-checkbox v-model="details" label="Incluir Detalles" class="ma-0 mr-2" hide-details/>
            <v-card @click="exportToExcel" class="pa-1 text-center" outlined>
                <div><v-icon small>mdi-file-export-outline</v-icon></div>
                EXPORTAR A EXCEL
            </v-card>
        </v-card>
    </v-card-text>
    <v-divider/>
    <v-data-table
        :headers="headers"
        :items="computedList"
        :items-per-page="15"
        :loading="fetching"
        :expanded.sync="expanded"
        show-expand
        item-key="comercio"
        >
        <!-- eslint-disable-next-line -->
        <template v-slot:item.comercio="{ item }">
            <v-btn text small @click="open(item, 'window')">
                <v-icon class="mr-2" small>mdi mdi-eye-outline</v-icon>
                {{ item.comercio }} 
            </v-btn>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.venta="{ item }">
            <Venta :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.comision="{ item }">
            <Comision :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.premio="{ item }">
            <Premio :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.total="{ item }">
            <Total :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.banqueo="{ item }">
            <Banqueo :reporte="item"/>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:expanded-item="{ item }">
            <td :colspan="headers.length + 1" class="pa-4">
                <JuegoMinimal :params="{ ... params, ... item.comercioParam }"/>
            </td>
        </template>
    </v-data-table>
</v-card>
</template>

<script>
import * as excelJS from 'exceljs';
import { saveAs } from "file-saver";

import JuegoMinimal from '../juego/minimal.vue';

import ReportePorComercioService from '@/services/reporte/ventas/ReportePorComercioService';
import ReporteDetalladaService from '@/services/reporte/ventas/ReporteDetalladaService';

import Venta from '@/components/entities/reporte/components/venta.vue';
import Comision from '@/components/entities/reporte/components/comision.vue';
import Premio from '@/components/entities/reporte/components/premio.vue';
import Total from '@/components/entities/reporte/components/total.vue';
import Banqueo from '@/components/entities/reporte/components/banqueo.vue';

import Summary from '@/components/entities/reporte/venta/divisa/summary.vue';

export default {
    components: {
        Venta,
        Comision,
        Premio,
        Total,
        Banqueo,
        Summary,
        JuegoMinimal
    },
    props: {
        params: {
            defaults: function() {
                return {};
            },
        },
        context: {
            default: 'comercio',
        },
    },
    data: function() { 
        return {
            exceloading: false,
            fetching: false,
            list: [],
            expanded: [],
            summaryParams: {},
            details: false,
        };
    },
    computed: {
        headers: function () {
            const showBanqueo = this.list.some((report) => report.banqueo[0][0]);
            return [
                ... this.context == 'sistema' ? [{ text: 'Sistema', align: 'start', value: 'comercio' }] : [{ text: 'Comercio', align: 'start', value: 'comercio' }],
                { text: 'Ventas', value: 'venta' },
                { text: 'Comisión', value: 'comision' },
                { text: 'Premio', value: 'premio' },
                { text: 'Total', value: 'total'},
                ... showBanqueo ? [{ text: 'Banqueo',align: 'center', value: 'banqueo' }] : [],
            ];
        },
        divisa: function () {
            return this.$store.getters['persist/divisa/selected'];
        },
        user: function () {
            return this.$store.getters['persist/auth/user'];
        },
        computedList: function () {
            return this.list.map(reporte => {
                const comercioParam = {};

                comercioParam[`${reporte.comercio_type}_id`] = reporte.comercio_id;
            
                return {
                    ... reporte,
                    comercioParam,
                };
            });
        }
    },
    mounted: function () {
        this.init();
    },
    methods: {
        init: function () {
            this.fetch();
            this.summaryParams = { ... this.params, divisa_id: this.divisa.id, force_comercio_grouping: 1, lower_comercio_level: 1 };
        },
        fetch: async function () {
            this.fetching = true;
            this.list = [];
            this.expaned = [];

            const params = { ... this.params, divisa_id: this.divisa.id, force_comercio_grouping: 1, lower_comercio_level: 1 };

            if (this.context == 'sistema') {
                params['group_by'] = 'sistema';
                params['comercio_type'] = 'sistema';
            }

            try {
                const {
                    reportList
                } = await ReportePorComercioService.getConsolidado(params);

                this.list = reportList;
            } catch (error) {
                console.log(error);
            }

            this.fetching = false;
        },
        open: function (reporte, context = 'tab') { // MEJORAR
            const comercio = {};
            if (this.user.comercio_type !== 'operadora') comercio[this.getComType(reporte.comercio_type)] = reporte.comercio_id;
            const params = {
                ... this.params,
                ...comercio,
                ... context == 'window' ? { 'minimal': 1, 'no-layout': 1 }: {},
            };

            if (this.context == 'sistema') {
                params['group_by'] = 'sistema';
                params['comercio_type'] = 'sistema';
            }

            const route = this.$router.resolve({
                name: ({
                    'comercio': 'reporte.consolidado.comercio',
                    'sistema': 'operadora.sistema.reporte.sistema',
                })[this.context],
                query: params,
            });

            if (context == 'tab') return window.open(new URL(route.href, window.location.origin), '_blank').focus();
            if (context == 'window') return window.open(new URL(route.href, window.location.origin), '_blank', 'titlebar=no, status=no, menubar=no, height=600 width=1280');
        },
        async exportToExcel () {
            if (!this.list.length) return;
            this.exceloading = true;
            const workbook = new excelJS.Workbook();
            workbook.creator = '';
            workbook.lastModifiedBy = 'System';
            workbook.created = new Date();

            let sheet = workbook.addWorksheet("Reporte");

            sheet.addRow(['']);

            sheet.addRow([
                'Comercio', 
                'Ventas '+ this.divisa.code, 
                'Comision '+ this.divisa.code, 
                'Premios '+ this.divisa.code, 
                'Total '+ this.divisa.code, 
                'BanqueoA',
                'BanqueoB',
            ]);

            sheet.getRow(1).font  = {
                bold: true
            };

            sheet.getRow(2).font = {
                bold: true
            };

            const results = this.list.reduce((sumary, item) => { 
                sumary.ventas += parseFloat(item.venta.toFixed(2)); 
                sumary.comisiones += parseFloat(item.comision.toFixed(2)); 
                sumary.premios += parseFloat(item.premio.toFixed(2)); 
                sumary.totales += parseFloat(item.total.toFixed(2)); 
                sumary.banqueoa += parseFloat(item.banqueo[0][1].toFixed(2)); 
                sumary.banqueob += parseFloat(item.banqueo[1][1].toFixed(2)); 
                return sumary;
            }, {ventas: 0, comisiones: 0, premios: 0, totales: 0, banqueoa: 0, banqueob: 0});

            const comercio = [];
            if (this.user.comercio_type !== 'operadora') comercio[this.getComType(this.user.comercio_type)] = this.user.comercio_id; 

            const params = { ...this.params, divisa_id: this.divisa.id,  ...comercio};

            if (this.context == 'sistema') {
                params['group_by'] = 'sistema';
                params['comercio_type'] = 'sistema';
            }

            try {
                
                const reporteDetallado = await ReporteDetalladaService.get(params).then(({reportList}) => {
                    return reportList;
                });   
    
                this.list.forEach((reporte) => {
                    const rowCom = sheet.addRow([
                        reporte.comercio,
                        parseFloat(reporte.venta.toFixed(2)),
                        parseFloat(reporte.comision.toFixed(2)),
                        parseFloat(reporte.premio.toFixed(2)), 
                        parseFloat(reporte.total.toFixed(2)), 
                        parseFloat(reporte.banqueo[0][1].toFixed(2)),
                        parseFloat(reporte.banqueo[1][1].toFixed(2))  
                    ]);
                    if (this.details){
                        rowCom.eachCell((cell) => cell.style = {
                            fill: {
                                type: 'pattern',
                                pattern:'solid',
                                fgColor:{argb:'cccccc'}
                            }
                        });
                        const reporteDetalladoFiltradoPorComercio = reporteDetallado.filter(reporteDetalladoItem => reporteDetalladoItem.comercio_id == reporte.comercio_id);
                        reporteDetalladoFiltradoPorComercio.forEach(subreporte => {
                            sheet.addRow([
                                subreporte.juego,
                                parseFloat(subreporte.venta.toFixed(2)),
                                parseFloat(subreporte.comision.toFixed(2)),
                                parseFloat(subreporte.premio.toFixed(2)), 
                                parseFloat(subreporte.total.toFixed(2)), 
                                parseFloat(subreporte.banqueo[0][1].toFixed(2)),
                                parseFloat(subreporte.banqueo[1][1].toFixed(2))  
                            ]).outlineLevel = 1;
                        });
                    }
                    
                });
                const rmax = sheet.lastRow._number + 1;
                sheet.getCell('A' + rmax).value = 'Totales';
                sheet.getCell('B' + rmax).value = results.ventas;
                sheet.getCell('C' + rmax).value = results.comisiones;
                sheet.getCell('D' + rmax).value = results.premios;
                sheet.getCell('E' + rmax).value = results.totales;
                sheet.getCell('F' + rmax).value = results.banqueoa;
                sheet.getCell('G' + rmax).value = results.banqueob;
    
                sheet.columns.forEach(column => {
                    const lengths = column.values.map(v => v.toString().length);
                    const maxLength = Math.max(...lengths.filter(v => typeof v === 'number'));
                    column.width = maxLength + 2;
                });
                
                sheet.getCell('A1').fill = {
                    type: 'pattern',
                    pattern:'solid',
                    fgColor:{argb:'c9daf8'}
                };
                sheet.getColumn(1).alignment = {
                    vertical: "middle",
                    horizontal: "center",
                };
                const tittle = 'Reporte de Ventas por Comercio desde '
                + this.params.daterange[0].split("-").reverse().join("-")
                + ' hasta '
                + this.params.daterange[1].split("-").reverse().join("-");
                sheet.getCell('A1').value = tittle;
                sheet.mergeCells("A1:G1");
    
                if (!this.details) {
                    sheet.addConditionalFormatting({
                        ref: 'A2:G' + rmax,
                        rules: [
                            {
                            type: 'expression',
                            formulae: ['MOD(ROW(),2)=0'],
                            style: {fill: {type: 'pattern', pattern: 'solid', bgColor: {argb: 'cccccc'}}},
                            }
                        ]
                    });
                }
    
                const filename = 'Reporte Comercio ' + this.$luxon.now().toFormat('MM-dd HHmmss') + '.xlsx';
                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                    saveAs(blob, filename);
                });
                
            } catch (error) {
                console.error(error);
            }

            this.exceloading = false;
        },
        getComType: function (comercioType) {
            return {'master': 'master_id', 'comercializadora': 'comercializadora_id', 'grupo': 'grupo_id', 'taquilla': 'taquilla_id', 'sistema': 'sistema_id'}[comercioType];
        },
    },
    watch: {
        params: function () {
            this.init();
        },
        'fetching': function (fetching) {
            this.$emit('update:loading', fetching);
        }
    },
}
</script>